import Header from "../components/landing/Header";
import Hero from "../components/landing/Hero";
import ProblemSolution from "../components/landing/ProblemSolution";
import Features from "../components/landing/Features";
import Ecosystem from "../components/landing/Ecosystem";
import Products from "../components/landing/Products";
import Testimonials from "../components/landing/Testimonials";
import FAQ from "../components/landing/FAQ";
import FinalCTA from "../components/landing/FinalCTA";
import Footer from "../components/landing/Footer";
import WhatsAppWidget from "../components/landing/WhatsAppWidget";
import ExitIntentPopup from "../components/landing/ExitIntentPopup";
import { useEffect } from "react";
import { initGA4 } from "../lib/analytics";

export default function Landing() {
  useEffect(() => {
    initGA4();
  }, []);

  return (
    <div className="min-h-screen bg-cream" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <ProblemSolution />
        <Features />
        <Ecosystem />
        <Products />
        <Testimonials />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
      <WhatsAppWidget />
      <ExitIntentPopup />
    </div>
  );
}
